import {
  HiqLrpTypeCodeNames,
  RmaCommodityTypeNames,
  RmaLrpCommodityCodes,
  RmaLrpCommodityNames,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { z, zDecimalNullable, zDecimalRequired } from '@harvestiq/zod';
import { dbLrpRateDailySchema } from './db-lrp-rate-daily';

export const lrpQuoteSchema = dbLrpRateDailySchema
  .omit({
    coveragePrice: true,
  })
  .extend({
    commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
    commodityName: z.nativeEnum(RmaLrpCommodityNames),
    commodityTypeName: z.nativeEnum(RmaCommodityTypeNames),
    typeCode: z.nativeEnum(RmaLrpTypeCodes),
    typeDisplay: z.nativeEnum(HiqLrpTypeCodeNames),
    optionsName: z.string(),
    priceAdjustmentFactor: zDecimalRequired(),
    barchartFuturesSymbol: z.string().nullable(),
    endDateMonth: z.string(),
    endDateMonthName: z.string(),
    isPre2026BeginningFarmerRancher: z.boolean(),
    isVeteranFarmerRancher: z.boolean(),
    beginningFarmerRancherCropYearCount: z.number().nullable(),
    // below are obtained from barchart futures data
    monthDiff: z.number(),
    cmeEquivalentDateMonth: z.string(),

    marketingMonthNumber: z.string().optional(),

    coveragePricePerCwt: zDecimalRequired(),
    coveragePricePerHead: zDecimalRequired(),
    coveragePriceTotal: zDecimalRequired(),

    livestockRate: zDecimalRequired(),
    expectedEndingValueTotal: zDecimalRequired(),
    expectedEndingValuePerHead: zDecimalRequired(),
    expectedEndingValuePerCwt: zDecimalRequired(),

    liabilityAmountTotal: zDecimalRequired(),
    liabilityAmountPerHead: zDecimalRequired(),
    liabilityAmountPerCwt: zDecimalRequired(),

    totalPremium: zDecimalRequired(),
    totalPremiumPerHead: zDecimalRequired(),
    totalPremiumPerCwt: zDecimalRequired(),

    subsidyRate: zDecimalRequired(),
    subsidyTotal: zDecimalRequired(),
    subsidyPerHead: zDecimalRequired(),
    subsidyPerCwt: zDecimalRequired(),

    producerPremiumTotal: zDecimalRequired(),
    producerPremiumPerHead: zDecimalRequired(),
    producerPremiumPerCwt: zDecimalRequired(),

    comparisonPricePerCwt: zDecimalRequired(),
    comparisonPricePerHead: zDecimalRequired(),
    comparisonPriceTotal: zDecimalRequired(),

    // --- BARCHART FUTURES DATA ---
    finalSettlementPerCwt: zDecimalNullable(),
    finalSettlementPerHead: zDecimalNullable(),
    finalSettlementTotal: zDecimalNullable(),
    last: zDecimalNullable(),
    previousClose: zDecimalNullable(),
    settlement: zDecimalNullable(),
    previousSettlement: zDecimalNullable(),
    savingsVsCmeTrade: zDecimalNullable(),
    savingsVsCmeTradeDollar: zDecimalNullable(),
    publicationDate: z.string().nullable(),
  });

export type LrpQuote = z.infer<typeof lrpQuoteSchema>;

export function isLrpQuote(quote: any): quote is LrpQuote {
  return (
    quote &&
    quote.typeCode &&
    Object.values(RmaLrpTypeCodes).includes(quote.typeCode)
  );
}
